"use strict";
exports.__esModule = true;
var selectorSchema = {
    $id: 'muninn.selectorSchema',
    oneOf: [{ type: 'string' }, { type: 'array', items: { type: 'string' } }]
};
exports["default"] = selectorSchema;
